module.exports = "/favicon-bfw.ico?/jAb4Sd";